// client/src/api/auth.ts

import { post } from "./fetch";

type LoginResult = {
  message?: string;
  data?: { token?: string };
  statusCode?: number;
  ok?: boolean;
};

enum UserPath {
  REGISTER = "/user/register",
  LOGIN = "/user/login",
}

// On retire les génériques, car `post` n'est pas défini pour les utiliser
export const register = (username: string, password: string) => {
  return post({ username, password }, UserPath.REGISTER);
};

export const login = (username: string, password: string) => {
  return post({ username, password }, UserPath.LOGIN);
};

// Petit utilitaire pour extraire le token facilement
export const extractToken = (res: LoginResult) => {
  return res?.data?.token || "";
};